import { inject, observer }               from "mobx-react";
import * as React                         from "react";
import ConfirmationModal                  from "../../../Views/Components/Modal/ConfirmationModal";
import ModalService                       from "../../../Service/ModalService";
import { Container }                      from "typedi";
import { ModalStore }                     from "../../../Store/ModalStore";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { TutorialStore }                  from "../../../Store/TutorialStore";
import { Tutorial }                       from "../../../Models/Tutorial/Tutorial";

interface IDeleteTutorialViewModelProps extends WithNamespaces {
    ModalStore?: ModalStore;
    TutorialStore?: TutorialStore;
    tutorial: Tutorial;
}

@inject(ModalStore.NAME_STORE, TutorialStore.NAME_STORE)
@observer
class DeleteTutorialViewModel extends React.Component<IDeleteTutorialViewModelProps, {}> {
    private readonly modalService: ModalService;

    constructor(props: IDeleteTutorialViewModelProps) {
        super(props);

        this.modalService = Container.get(ModalService);
    }

    get tutorialStore(): TutorialStore {
        return this.props.TutorialStore as TutorialStore;
    }

    get modalStore(): ModalStore {
        return this.props.ModalStore as ModalStore;
    }

    public action = async () => {
        const {tutorial} = this.props;

        this.tutorialStore.setSpinner(true);
        await this.tutorialStore.deleteById(tutorial.getId());
        const data = await this.tutorialStore.getPaginate();

        this.tutorialStore
            .setPages(data.pages)
            .setTutorials(data.data)
            .setSpinner(false);

        this.modalService.closeModal();
    };

    public render(): React.ReactNode {
        const {t} = this.props;

        return (
            <ConfirmationModal
                handleClose={this.modalService.closeModal}
                open={this.modalStore.getModal().getOpenModal()}
                action={this.action}
                spinner={this.tutorialStore.getSpinner()}
                title={t("confirm.content")}
                content={t("confirm.title")}
            />
        );
    }
}

export default withNamespaces("modal")(DeleteTutorialViewModel);
